import { render } from "./HtmlViewer.vue?vue&type=template&id=2e973baf&scoped=true"
import script from "./HtmlViewer.vue?vue&type=script&lang=js"
export * from "./HtmlViewer.vue?vue&type=script&lang=js"

import "./HtmlViewer.vue?vue&type=style&index=0&id=2e973baf&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e973baf"]])

export default __exports__